import { FieldSubSectionProps } from './FieldSubSection.types'
import style from './FieldSubSection.module.scss'

export function FieldSubSection({ children }: FieldSubSectionProps) {
  return <div className={style.container}>{children}</div>
}
